module.exports = __webpack_public_path__ + "img/icon_manejo_coordinacion_evaluacion_hover.97ba1e30.svg";